(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blogs-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sliderContainer = document.querySelector('.all_blogs_slider_container');
    const slides = document.querySelectorAll('.blog_slide');
    const dots = document.querySelectorAll('.dot');

    let index = 0;
    const intervalTime = 5000;
    let autoSlide;

    let isDragging = false;
    let startPos = 0;
    let endPos = 0;

    function updateSlide() {
      const translateValue = -(index * 100); // Use percentage for responsiveness
      sliderContainer.style.transform = `translateX(${translateValue}%)`;
      sliderContainer.style.transition = 'transform 0.6s ease-in-out';

      slides.forEach((slide, i) => slide.classList.toggle('active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
    }

    function nextSlide() {
      if (index < slides.length - 1) index++;
      updateSlide();
    }

    function prevSlide() {
      if (index > 0) index--;
      updateSlide();
    }

    function startAutoSlide() {
      autoSlide = setInterval(nextSlide, intervalTime);
    }

    function stopAutoSlide() {
      clearInterval(autoSlide);
    }

    function touchStart(event) {
      stopAutoSlide();
      isDragging = true;
      startPos = getPositionX(event);
      sliderContainer.classList.add('grabbing');
    }

    function touchMove(event) {
      if (!isDragging) return;
      endPos = getPositionX(event);
    }

    function touchEnd() {
      if (!isDragging) return;
      isDragging = false;
      sliderContainer.classList.remove('grabbing');

      const movedBy = startPos - endPos;
      const threshold = window.innerWidth * 0.1; // Move at least 10% of screen width

      if (movedBy > threshold) {
        nextSlide();
      } else if (movedBy < -threshold) {
        prevSlide();
      } else {
        updateSlide();
      }

      startAutoSlide();
    }

    function getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }

    // Event listeners for grabbing/swiping
    sliderContainer.addEventListener('mousedown', touchStart);
    sliderContainer.addEventListener('mousemove', touchMove);
    sliderContainer.addEventListener('mouseup', touchEnd);
    sliderContainer.addEventListener('mouseleave', touchEnd);
    sliderContainer.addEventListener('touchstart', touchStart);
    sliderContainer.addEventListener('touchmove', touchMove);
    sliderContainer.addEventListener('touchend', touchEnd);

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        index = i;
        updateSlide();
      });
    });

    startAutoSlide();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    

  
   document.addEventListener("DOMContentLoaded", function () {
        function getBlogInfoFromDOM() {
            // Your custom selectors
            const blogTitleElement = document.querySelector(".h3.article_slide_title");
            const blogImageElement = document.querySelector(".article_banner_inner .slide-image img");
    
            const blogTitle = blogTitleElement ? blogTitleElement.innerText.trim() : null;
            const blogImage = blogImageElement ? blogImageElement.src : null;
            const blogUrl = window.location.href;
    
            if (!blogTitle || !blogUrl) return;
    
            const blogData = { title: blogTitle, image: blogImage || "", url: blogUrl };
    
            let recentBlogs = JSON.parse(localStorage.getItem("recentBlogs")) || [];
    
            // Remove existing entry
            recentBlogs = recentBlogs.filter(blog => blog.url !== blogUrl);
    
            // Add new blog to top
            recentBlogs.unshift(blogData);
    
            // Keep only the latest 4 (we display max 3 and exclude current)
            recentBlogs = recentBlogs.slice(0, 4);
    
            localStorage.setItem("recentBlogs", JSON.stringify(recentBlogs));
        }
    
        function displayRecentBlogs() {
            const container = document.querySelector("#recent-blogs-container");
            if (!container) return;
    
            const currentUrl = window.location.href;
            let recentBlogs = JSON.parse(localStorage.getItem("recentBlogs")) || [];
    
            // Exclude current blog
            recentBlogs = recentBlogs.filter(blog => blog.url !== currentUrl);
    
            // Limit to 3 displayed
            recentBlogs = recentBlogs.slice(0, 3);
    
            if (recentBlogs.length === 0) {
                container.innerHTML = "<p>No recently visited blogs.</p>";
                return;
            }
    
            const html = recentBlogs.map(blog => `
                <div class="recent-blog-item">
                    <a href="${blog.url}">
                        ${blog.image ? `
                        <div class="article_img_container">
                          <img src="${blog.image}" alt="${blog.title}" loading="lazy" />
                        </div>
                        ` : ""}
                        <div class="article_title">
                          <p>${blog.title}</p>
                        </div>
                    </a>
                </div>
            `).join("");
    
            container.innerHTML = html;
        }
    
        // Save blog info only on blog post pages
        if (window.location.pathname.includes("/blogs/")) {
            getBlogInfoFromDOM();
        }
    
        // Always attempt to show recent blogs
        displayRecentBlogs();
    });





  } catch(e) { console.error(e); }
})();
})();
